/**
 * Business identity shown in the footer, legal pages and support links.
 * Phone and WhatsApp stay hidden until REACT_APP_SUPPORT_PHONE is set.
 * REACT_APP_COMPANY_ADDRESS is the registered office shown on Contact.
 */
export const COMPANY = {
  brand: "EmergencyQR",
  legalName: "Dityaverse Pvt. Ltd.",
  website: "https://emergencyqr.in",
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || "support@emergencyqr.in",
  supportPhone: (process.env.REACT_APP_SUPPORT_PHONE || "").replace(/\D/g, "").slice(-10),
  address: process.env.REACT_APP_COMPANY_ADDRESS || "",
  responseTime: "We reply within 24 hours (Monday to Saturday).",
};

export const supportWhatsAppUrl = (text = "") =>
  COMPANY.supportPhone
    ? `https://wa.me/91${COMPANY.supportPhone}${text ? `?text=${encodeURIComponent(text)}` : ""}`
    : null;

export const LEGAL_LINKS = [
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms of Service" },
  { to: "/refund-policy", label: "Refund & Cancellation" },
  { to: "/shipping-policy", label: "Shipping Policy" },
  { to: "/contact", label: "Contact Us" },
];
